"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DIALOG_ID = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _FullscreenOverlay = _interopRequireDefault(require("./FullscreenOverlay.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

function Transition(props) {
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], (0, _extends2["default"])({
    direction: "up"
  }, props));
}

var DIALOG_ID = 'fullscreenOverlay';
exports.DIALOG_ID = DIALOG_ID;

var FullscreenOverlay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FullscreenOverlay, _React$Component);

  var _super = _createSuper(FullscreenOverlay);

  function FullscreenOverlay() {
    (0, _classCallCheck2["default"])(this, FullscreenOverlay);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FullscreenOverlay, [{
    key: "render",
    value: function render() {
      if (this.props.transition) {
        return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
          fullScreen: this.props.fullScreen,
          open: this.props.open,
          onClose: this.props.closeDialog,
          transition: Transition,
          classes: {
            root: _DeviceInfoHelper["default"].isInternetExplorer() ? _FullscreenOverlay["default"].rootIE : _FullscreenOverlay["default"].root,
            paper: _FullscreenOverlay["default"].paper
          },
          PaperProps: {
            style: {
              backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : null
            }
          }
        }, this.props.children);
      }

      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        fullScreen: this.props.fullScreen,
        open: this.props.open,
        onClose: this.props.closeDialog,
        classes: {
          root: _FullscreenOverlay["default"].root,
          paper: _FullscreenOverlay["default"].paper
        },
        PaperProps: {
          style: {
            backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : null
          }
        }
      }, this.props.children);
    }
  }]);
  return FullscreenOverlay;
}(_react["default"].Component);

FullscreenOverlay.propTypes = {
  fullScreen: _propTypes["default"].bool,
  closeDialog: _propTypes["default"].func,
  transition: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  backgroundColor: _propTypes["default"].string
};
FullscreenOverlay.defaultProps = {
  fullScreen: true,
  transition: false
};
var _default = FullscreenOverlay;
exports["default"] = _default;